import React from "react";
import { Container, Row, Col, Card, Button} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
// import { useAccountingReports } from "../../contextjs/AccountingReportsContext";

const AccountingReports = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div>
            <div className="back-button-container" >
                <Button variant="secondary" onClick={handleBack}>Back</Button>
            </div>
            <Container className='mt-5'>
                <h1 className='text-center mb-4'>Accounting Reports</h1>
                <Row>
                    <Col md={4} className='mb-4'>
                        <Link to='/accounting/reports/balance-sheet' className='text-decoration-none'>
                            <Card className='text-white bg-primary'>
                                <Card.Body>
                                    <Card.Title>Balance Sheet</Card.Title>
                                    <Card.Text>View balance sheet report</Card.Text>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>

                    <Col md={4} className='mb-4'>
                        <Link to='/accounting/reports/income-statement' className='text-decoration-none'>
                            <Card className='text-white bg-success'>
                                <Card.Body>
                                    <Card.Title>Income Statement</Card.Title>
                                    <Card.Text>View income statement report</Card.Text>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>

                    <Col md={4} className='mb-4'>
                        <Link to='/accounting/reports/trial-balance' className='text-decoration-none'>
                            <Card className='text-white bg-warning'>
                                <Card.Body>
                                    <Card.Title>Trial Balance</Card.Title>
                                    <Card.Text>View trial balance report</Card.Text>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>

                    <Col md={4} className='mb-4'>
                        <Link to='/accounting/reports/income-statement-fy-selector' className='text-decoration-none'>
                            <Card className='text-white bg-info'>
                                <Card.Body>
                                    <Card.Title>Historical Income Statement</Card.Title>
                                    <Card.Text>View historical income statement report</Card.Text>
                                </Card.Body>
                            </Card>
                        </Link>
                    </Col>
                    {/*add more reports here*/}
                </Row>
            </Container>
        </div>
    )
}

export default AccountingReports;